import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class MonthDayDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    // If the display format is for input display, show only MM/DD
    if (displayFormat === 'input') {
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${month}/${day}`;
    }

    // For other formats, use the parent's formatting
    return super.format(date, displayFormat);
  }

  override parse(value: any): Date | null {
    if (typeof value === 'string') {
      const parts = value.split('/');
      if (parts.length === 2) {
        // Parse MM/DD format
        const month = parseInt(parts[0], 10);
        const day = parseInt(parts[1], 10);

        // Use current year as default, will be overridden when combined with dropdown year
        const year = new Date().getFullYear();

        if (!isNaN(month) && !isNaN(day) && month >= 1 && month <= 12 && day >= 1 && day <= 31) {
          return new Date(year, month - 1, day);
        }
      }
    }

    return super.parse(value);
  }
}
